// IATA codes. Used to build Google flight-status queries and to populate the
// airline Autocomplete. The Autocomplete is freeSolo, so this list does not
// need to be exhaustive — carriers outside it can be typed by hand.
export const AIRLINES = [
  { name: "Aer Lingus", code: "EI" },
  { name: "Aeromexico", code: "AM" },
  { name: "Air Canada", code: "AC" },
  { name: "Air France", code: "AF" },
  { name: "Air New Zealand", code: "NZ" },
  { name: "Alaska Airlines", code: "AS" },
  { name: "Allegiant Air", code: "G4" },
  { name: "American Airlines", code: "AA" },
  { name: "ANA", code: "NH" },
  { name: "Avianca", code: "AV" },
  { name: "British Airways", code: "BA" },
  { name: "Cathay Pacific", code: "CX" },
  { name: "Copa Airlines", code: "CM" },
  { name: "Delta Air Lines", code: "DL" },
  { name: "Emirates", code: "EK" },
  { name: "Etihad Airways", code: "EY" },
  { name: "Frontier Airlines", code: "F9" },
  { name: "Hawaiian Airlines", code: "HA" },
  { name: "Iberia", code: "IB" },
  { name: "Icelandair", code: "FI" },
  { name: "ITA Airways", code: "AZ" },
  { name: "Japan Airlines", code: "JL" },
  { name: "JetBlue Airways", code: "B6" },
  { name: "KLM", code: "KL" },
  { name: "Korean Air", code: "KE" },
  { name: "LATAM Airlines", code: "LA" },
  { name: "Lufthansa", code: "LH" },
  { name: "Norwegian", code: "DY" },
  { name: "Qantas", code: "QF" },
  { name: "Qatar Airways", code: "QR" },
  { name: "Ryanair", code: "FR" },
  { name: "Singapore Airlines", code: "SQ" },
  { name: "Southwest Airlines", code: "WN" },
  { name: "Spirit Airlines", code: "NK" },
  { name: "Sun Country Airlines", code: "SY" },
  { name: "Swiss", code: "LX" },
  { name: "TAP Air Portugal", code: "TP" },
  { name: "Turkish Airlines", code: "TK" },
  { name: "United Airlines", code: "UA" },
  { name: "Virgin Atlantic", code: "VS" },
  { name: "WestJet", code: "WS" },
]
